import React, { useEffect, useState } from "react";
import { Layout, PlayerCard } from "..";
import {
  Loader,
  UpgradeContainer,
  RelativePercentageDiv,
} from "../../components";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import { calculatePercj } from "../../lib/cabbStats";
import { useLocation } from "react-router-dom";

const Game = ({ appData }) => {
  const userLocal = secureLocalStorage.getItem("userLocal");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedChart, setSelectedChart] = useState("overview");
  const [isCardPopupActive, setIsCardPopupActive] = useState(false);
  const [activePlayer, setActivePlayer] = useState(null);
  const [activePlayerTeam, setActivePlayerTeam] = useState(null);
  const [game, setGame] = useState(null);
  const location = useLocation();
  let gameId = window.location.pathname.replace("/app/game/", "");
  const gameProps = location.state.game;

  useEffect(() => {
    if (gameProps) {
      setGame(gameProps);
      setIsLoading(false);
    }
  }, [gameProps, appData]);

  function calcualtePoints(game, team) {
    let points = 0;
    if (team === "local_team") {
      game.local_stats.forEach((element) => {
        points += Number(element.pts);
      });
    } else if (team === "visit_team") {
      game.visit_stats.forEach((element) => {
        points += Number(element.pts);
      });
    }
    return points;
  }

  const handleDownloadImage = (player, team, activeTeam) => {
    setActivePlayer(player);
    setActivePlayerTeam([game, activeTeam]);
    setIsCardPopupActive(true);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Layout isPositionUnset={true}>
      {userLocal !== undefined &&
      userLocal !== null &&
      userLocal !== null &&
      userLocal?.plan !== "Basic" ? (
        <Container>
          {game !== null ? (
            <>
              <div className="header">
                <div className="description">
                  <p className="teams">
                    {
                      appData?.teams?.filter(
                        (team) => team._id === game.local_team
                      )[0]?.name
                    }{" "}
                    vs{" "}
                    {
                      appData?.teams?.filter(
                        (team) => team._id === game.visit_team
                      )[0]?.name
                    }
                  </p>
                  <p>{game.stage}</p>
                </div>
                <div className="box-score">
                  <p>
                    {
                      appData?.teams?.filter(
                        (team) => team._id === game.local_team
                      )[0]?.name
                    }
                  </p>
                  <div className="score-container">
                    <div className="score">
                      <p>{calcualtePoints(game, "local_team")}</p>
                      <p>{calcualtePoints(game, "visit_team")}</p>
                    </div>
                    <p>{game.date}</p>
                  </div>
                  <p>
                    {
                      appData?.teams?.filter(
                        (team) => team._id === game.visit_team
                      )[0]?.name
                    }
                  </p>
                </div>
              </div>
              <div className="chart-options_container">
                <div
                  className={`chart-option ${
                    selectedChart === "overview" ? "active" : null
                  }`}
                >
                  <button
                    onClick={(e) => {
                      setSelectedChart("overview");
                    }}
                  >
                    Estadisticas
                  </button>
                </div>
                <div
                  className={`chart-option ${
                    selectedChart === "boxScore" ? "active" : null
                  }`}
                >
                  <button
                    onClick={(e) => {
                      setSelectedChart("boxScore");
                    }}
                  >
                    Box score
                  </button>
                </div>
              </div>
              <div
                className={`content ${
                  selectedChart === "overview" ? "active" : null
                }`}
              >
                <div className="content-item">
                  <p>
                    {calculatePercj([game], game.local_team, "FGTot")}/
                    {calculatePercj([game], game.local_team, "FGA")} (
                    {calculatePercj([game], game.local_team, "FGP").toFixed(1)}
                    %)
                  </p>
                  <p>Tiro de campo</p>
                  <p>
                    {calculatePercj([game], game.visit_team, "FGTot")}/
                    {calculatePercj([game], game.visit_team, "FGA")} (
                    {calculatePercj([game], game.visit_team, "FGP").toFixed(1)}
                    %)
                  </p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      calculatePercj([game], game.local_team, "FGP").toFixed(
                        1
                      ) / 2
                    }
                    rightValue={
                      calculatePercj([game], game.visit_team, "FGP").toFixed(
                        1
                      ) / 2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>
                    {calculatePercj([game], game.local_team, "FT")}/
                    {calculatePercj([game], game.local_team, "FTATot")} (
                    {calculatePercj([game], game.local_team, "FTP").toFixed(1)}
                    %)
                  </p>
                  <p>Tiros Libres</p>
                  <p>
                    {calculatePercj([game], game.visit_team, "FT")}/
                    {calculatePercj([game], game.visit_team, "FTATot")} (
                    {calculatePercj([game], game.visit_team, "FTP").toFixed(1)}
                    %)
                  </p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      calculatePercj([game], game.local_team, "FTP").toFixed(
                        1
                      ) / 2
                    }
                    rightValue={
                      calculatePercj([game], game.visit_team, "FTP").toFixed(
                        1
                      ) / 2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>
                    {calculatePercj([game], game.local_team, "THREEP")}/
                    {calculatePercj([game], game.local_team, "THREEPA")} (
                    {calculatePercj([game], game.local_team, "THREEPP").toFixed(
                      1
                    )}
                    %)
                  </p>
                  <p>Triples</p>
                  <p>
                    {calculatePercj([game], game.visit_team, "THREEP")}/
                    {calculatePercj([game], game.visit_team, "THREEPA")} (
                    {calculatePercj([game], game.visit_team, "THREEPP").toFixed(
                      1
                    )}
                    %)
                  </p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      calculatePercj(
                        [game],
                        game.local_team,
                        "THREEPP"
                      ).toFixed(1) / 2
                    }
                    rightValue={
                      calculatePercj(
                        [game],
                        game.visit_team,
                        "THREEPP"
                      ).toFixed(1) / 2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "ASSTot")}</p>
                  <p>Asistencias</p>
                  <p>{calculatePercj([game], game.visit_team, "ASSTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "ASSTot") /
                        (calculatePercj([game], game.local_team, "ASSTot") +
                          calculatePercj([game], game.visit_team, "ASSTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "ASSTot") /
                        (calculatePercj([game], game.local_team, "ASSTot") +
                          calculatePercj([game], game.visit_team, "ASSTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>
                    {calculatePercj([game], game.local_team, "ORBTot") +
                      calculatePercj([game], game.local_team, "DRBTot")}
                  </p>
                  <p>Rebotes</p>
                  <p>
                    {calculatePercj([game], game.visit_team, "ORBTot") +
                      calculatePercj([game], game.visit_team, "DRBTot")}
                  </p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "ORBTot") /
                        (calculatePercj([game], game.local_team, "ORBTot") +
                          calculatePercj([game], game.visit_team, "ORBTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "ORBTot") /
                        (calculatePercj([game], game.local_team, "ORBTot") +
                          calculatePercj([game], game.visit_team, "ORBTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "ORBTot")}</p>
                  <p>Rebotes Ofensivos</p>
                  <p>{calculatePercj([game], game.visit_team, "ORBTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "ORBTot") /
                        (calculatePercj([game], game.local_team, "ORBTot") +
                          calculatePercj([game], game.visit_team, "ORBTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "ORBTot") /
                        (calculatePercj([game], game.local_team, "ORBTot") +
                          calculatePercj([game], game.visit_team, "ORBTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "DRBTot")}</p>
                  <p>Rebotes Defensivos</p>
                  <p>{calculatePercj([game], game.visit_team, "DRBTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "DRBTot") /
                        (calculatePercj([game], game.local_team, "DRBTot") +
                          calculatePercj([game], game.visit_team, "DRBTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "DRBTot") /
                        (calculatePercj([game], game.local_team, "DRBTot") +
                          calculatePercj([game], game.visit_team, "DRBTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "STLTot")}</p>
                  <p>Robos</p>
                  <p>{calculatePercj([game], game.visit_team, "STLTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "STLTot") /
                        (calculatePercj([game], game.local_team, "STLTot") +
                          calculatePercj([game], game.visit_team, "STLTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "STLTot") /
                        (calculatePercj([game], game.local_team, "STLTot") +
                          calculatePercj([game], game.visit_team, "STLTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "BLKTot")}</p>
                  <p>Bloqueos</p>
                  <p>{calculatePercj([game], game.visit_team, "BLKTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "BLKTot") /
                        (calculatePercj([game], game.local_team, "BLKTot") +
                          calculatePercj([game], game.visit_team, "BLKTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "BLKTot") /
                        (calculatePercj([game], game.local_team, "BLKTot") +
                          calculatePercj([game], game.visit_team, "BLKTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "TORTot")}</p>
                  <p>Pérdidas</p>
                  <p>{calculatePercj([game], game.visit_team, "TORTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "TORTot") /
                        (calculatePercj([game], game.local_team, "TORTot") +
                          calculatePercj([game], game.visit_team, "TORTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "TORTot") /
                        (calculatePercj([game], game.local_team, "TORTot") +
                          calculatePercj([game], game.visit_team, "TORTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
                <div className="content-item">
                  <p>{calculatePercj([game], game.local_team, "PFTot")}</p>
                  <p>Faltas</p>
                  <p>{calculatePercj([game], game.visit_team, "PFTot")}</p>
                </div>
                <div className="container">
                  <RelativePercentageDiv
                    leftValue={
                      ((calculatePercj([game], game.local_team, "PFTot") /
                        (calculatePercj([game], game.local_team, "PFTot") +
                          calculatePercj([game], game.visit_team, "PFTot"))) *
                        100) /
                      2
                    }
                    rightValue={
                      ((calculatePercj([game], game.visit_team, "PFTot") /
                        (calculatePercj([game], game.local_team, "PFTot") +
                          calculatePercj([game], game.visit_team, "PFTot"))) *
                        100) /
                      2
                    }
                  />
                </div>
              </div>
              <div
                className={`content ${
                  selectedChart === "boxScore" ? "active" : null
                }`}
              >
                <div className="team">
                  <h3>
                    {
                      appData?.teams?.filter(
                        (team) => team._id === game.local_team
                      )[0]?.name
                    }
                  </h3>
                  <div className="team-container">
                    <div className="team-header">
                      <p style={{ flexBasis: "5%" }}>Nº</p>
                      <p style={{ width: "50px", flexBasis: "auto" }}></p>
                      <p className="name">Nombre</p>
                      <p>MINS</p>
                      <p>PTS</p>
                      <p>2PA</p>
                      <p>2PI</p>
                      <p>2P%</p>
                      <p>3PA</p>
                      <p>3PI</p>
                      <p>3P%</p>
                      <p>TLA</p>
                      <p>TLI</p>
                      <p>TL%</p>
                      <p>REBD</p>
                      <p>REBO</p>
                      <p>REB</p>
                      <p>AS</p>
                      <p>REC</p>
                      <p>PER</p>
                      <p>TAPC</p>
                      <p>TAPR</p>
                      <p>FALC</p>
                      <p>FALR</p>
                      <p>VAL</p>
                      <p>IMG</p>
                    </div>
                    {game.local_stats.map((player, index) => (
                      <div className={`player-container`}>
                        <p style={{ flexBasis: "5%" }}>
                          {
                            appData?.players?.filter(
                              (playerdb) => playerdb._id === player.player_id
                            )[0]?.player_number
                          }
                        </p>
                        <img src="/assets/user-icon.png" />
                        <p className="name">{player.player_name}</p>
                        <p>{player.mins}</p>
                        <p>{player.pts}</p>
                        <p>{player["2pA/I"].split("/")[0]}</p>
                        <p>{player["2pA/I"].split("/")[1]}</p>
                        <p>{player["2pPcj"]}</p>
                        <p>{player["3pA/I"].split("/")[0]}</p>
                        <p>{player["3pA/I"].split("/")[1]}</p>
                        <p>{player["3pPcj"]}</p>
                        <p>{player["tlA/I"].split("/")[0]}</p>
                        <p>{player["tlA/I"].split("/")[1]}</p>
                        <p>{player["tlPcj"]}</p>
                        <p>{player.rebDef}</p>
                        <p>{player.rebOff}</p>
                        <p>{player.rebTot}</p>
                        <p>{player.ass}</p>
                        <p>{player.rec}</p>
                        <p>{player.per}</p>
                        <p>{player.blocksMade}</p>
                        <p>{player.blocksRecibed}</p>
                        <p>{player.foulsMade}</p>
                        <p>{player.foulesRecibed}</p>
                        <p>{player.val}</p>
                        <button
                          onClick={() =>
                            handleDownloadImage(player, game, "local")
                          }
                          className="btn-primary ghost"
                        >
                          <img src="/assets/download-icon-b.png" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="team">
                  <h3>
                    {
                      appData?.teams?.filter(
                        (team) => team._id === game.visit_team
                      )[0]?.name
                    }
                  </h3>
                  <div className="team-container">
                    <div className="team-header">
                      <p style={{ flexBasis: "5%" }}>Nº</p>
                      <p style={{ width: "50px", flexBasis: "auto" }}></p>
                      <p className="name">Nombre</p>
                      <p>MINS</p>
                      <p>PTS</p>
                      <p>2PA</p>
                      <p>2PI</p>
                      <p>2P%</p>
                      <p>3PA</p>
                      <p>3PI</p>
                      <p>3P%</p>
                      <p>TLA</p>
                      <p>TLI</p>
                      <p>TL%</p>
                      <p>REBD</p>
                      <p>REBO</p>
                      <p>REB</p>
                      <p>AS</p>
                      <p>REC</p>
                      <p>PER</p>
                      <p>TAPC</p>
                      <p>TAPR</p>
                      <p>FALC</p>
                      <p>FALR</p>
                      <p>VAL</p>
                      <p>IMG</p>
                    </div>
                    {game.visit_stats.map((player, index) => (
                      <div className={`player-container`}>
                        <p style={{ flexBasis: "5%" }}>
                          {
                            appData?.players?.filter(
                              (playerdb) => playerdb._id === player.player_id
                            )[0]?.player_number
                          }
                        </p>
                        <img src="/assets/user-icon.png" />
                        <p className="name">{player.player_name}</p>
                        <p>{player.mins}</p>
                        <p>{player.pts}</p>
                        <p>{player["2pA/I"].split("/")[0]}</p>
                        <p>{player["2pA/I"].split("/")[1]}</p>
                        <p>{player["2pPcj"]}</p>
                        <p>{player["3pA/I"].split("/")[0]}</p>
                        <p>{player["3pA/I"].split("/")[1]}</p>
                        <p>{player["3pPcj"]}</p>
                        <p>{player["tlA/I"].split("/")[0]}</p>
                        <p>{player["tlA/I"].split("/")[1]}</p>
                        <p>{player["tlPcj"]}</p>
                        <p>{player.rebDef}</p>
                        <p>{player.rebOff}</p>
                        <p>{player.rebTot}</p>
                        <p>{player.ass}</p>
                        <p>{player.rec}</p>
                        <p>{player.per}</p>
                        <p>{player.blocksMade}</p>
                        <p>{player.blocksRecibed}</p>
                        <p>{player.foulsMade}</p>
                        <p>{player.foulesRecibed}</p>
                        <p>{player.val}</p>
                        <button
                          onClick={() =>
                            handleDownloadImage(player, game, "visit")
                          }
                          className="btn-primary ghost"
                        >
                          <img src="/assets/download-icon-b.png" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : null}
          {isCardPopupActive ? (
            <PlayerCard
              appData={appData}
              isBoxScore={true}
              activePlayer={activePlayer}
              activePlayerTeam={activePlayerTeam}
              setIsCardPopupActive={() => setIsCardPopupActive(false)}
            />
          ) : null}
        </Container>
      ) : (
        <UpgradeContainer />
      )}
    </Layout>
  );
};

export default Game;
